module.exports = __webpack_public_path__ + "static/nat-eliason-20c11f731f975216ef52bc70c88a6d0e.jpg";